// extracted by mini-css-extract-plugin
module.exports = {"loadingScreenContainer":"CopyTradeComponent_loadingScreenContainer__3q8lr"};